import { render, staticRenderFns } from "./TheLionsClubImprint.vue?vue&type=template&id=e45be858&scoped=true"
import script from "./TheLionsClubImprint.vue?vue&type=script&lang=js"
export * from "./TheLionsClubImprint.vue?vue&type=script&lang=js"
import style0 from "./TheLionsClubImprint.vue?vue&type=style&index=0&id=e45be858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45be858",
  null
  
)

export default component.exports